import {useState} from 'react';
// Redux
import {useSelector, useDispatch} from 'react-redux';
// Styles
import * as S from './RecommendedComboList.style';
// Selectors
import {
  recommendedCombosSelector,
  isAltAccoSelector,
} from '@stencil/hotels-cg-reducer/src/details/selectors';
// Icons
import HappyArrowDropIcon from '@stencil/icons/src/HappyArrowDropIcon/HappyArrowDropIcon';
// Components
import RecommendedComboRoomInfo from './RecommendedComboRoomInfo';
import RecommendedComboPrice from './RecommendedComboPrice';
import useNavigateToReviewPage from '@stencil/navigate-to-review-page-dweb';
// Utils
import {
  getComboFilteredRooms,
  getRoomsArrayForSelectedCombo,
} from '@stencil/hotels-utils/src/common-utils';
import useCurrentRoomData from '../../../../../../../hooks/useCurrentRoomData';

import {defaultTheme} from '@stencil/build-theme';
// Config
import {gaConfig} from '@stencil/hotels-config';
import UpsellComboInclusions from './UpsellComboInclusions';
// Omnitures
import {omnitureThunk, omnitureConfig} from '@stencil/omniture-analytics/src';
import {
  detailsClick,
  DetailsPageComponents,
} from '@stencil/omniture-analytics/src/constants/details';

//Types
import {RecommendedComboRoom} from '@stencil/hotels-types/src/details-cg/types';

const RecommendedComboList = ({handlOpenCalendar = () => {}}) => {
  const {DetailsGAClickEventActions} = gaConfig;

  // Selectors
  const comboListFromCg = useSelector(recommendedCombosSelector);
  const {activeBankCode} = useCurrentRoomData();
  const isAltAcco = useSelector(isAltAccoSelector);

  const getComboList = () => {
    let copyComboList = JSON.parse(JSON.stringify(comboListFromCg)) as RecommendedComboRoom[];
    copyComboList.map(element => {
      let filteredRooms = getComboFilteredRooms(element);
      element.rooms = filteredRooms;
    });
    return copyComboList;
  };

  const comboList = getComboList();

  const [visibleItems, setVisibleItems] = useState(1);

  const nonVisibleCombo = comboList.length - visibleItems;

  const [navigatorNew] = useNavigateToReviewPage();

  const dispatch = useDispatch();

  const navigateToReviewPageCaller = comboData => {
    const roomsInfo = getRoomsArrayForSelectedCombo({
      selectedComboId: comboData?.comboId,
      comboListFromCg: comboListFromCg,
    });
    navigatorNew({
      selectedRoomInfo: [...roomsInfo],
      rootLevelInfo: {
        searchType: 'R',
        promoCode: activeBankCode,
      },
    });
  };

  const showMoreCombos = () => {
    dispatch(
      omnitureThunk(omnitureConfig.pages.DetailsUnif, omnitureConfig.events.ctaClick, {
        cta: {
          name: `${DetailsPageComponents.RecommendedComboList}_${detailsClick.multiRoomEventActions.Combo_Expand_Clicked}`,
          type: omnitureConfig.ctaType.Button,
          componentName: DetailsPageComponents.RecommendedComboList,
          destination: '',
        },
      }),
    );
    setVisibleItems(comboList.length);
  };

  if (comboList.length > 0) {
    return (
      <>
        {comboList.map((item, comboIndex) => {
          const {comboTariff} = item;
          let roomData = {};
          return (
            <>
              {comboIndex + 1 <= visibleItems && (
                <S.MultiRoomComboSection id={comboIndex}>
                  <S.HeaderDiv>
                    <S.MultiRoomHeaderPara>
                      {`Combo ${comboIndex + 1 + ' - ' + item?.comboName} `}
                    </S.MultiRoomHeaderPara>
                    <S.MultiRoomSubHeaderPara>{item?.csbtl}</S.MultiRoomSubHeaderPara>
                  </S.HeaderDiv>

                  <S.MainContentDiv>
                    <S.MainContentLeftDiv>
                      {/*  Room Plan Data Starts Here */}

                      {(item?.rooms || []).map((comboRoomData, comboRoomIndex) => {
                        let totalRoomPlan = (item?.rooms || []).length;
                        let roomCount = comboRoomData?.roomCount;
                        let adultCount = comboRoomData?.adultCount;
                        let childCount = comboRoomData?.childCount;

                        return (comboRoomData?.ratePlans || []).map(
                          (roomPlanData, roomPlanIndex) => {
                            const roomCode = comboRoomData?.roomCode;
                            const roomHighlights = comboRoomData?.roomHighlights;
                            const roomImages = comboRoomData?.images || [];

                            const leftPanelProps = {
                              roomCode,
                              roomImages,
                              roomPlanData,
                              roomCount,
                              adultCount,
                              childCount,
                              roomTypeName: comboRoomData?.roomName,
                              roomHighlights,
                              roomDescription: comboRoomData?.description,
                              amenities: comboRoomData?.amenities,
                              roomReviews: comboRoomData?.roomReviews,
                            };

                            return (
                              <S.MultiRoomRow showBorderBottom={comboRoomIndex + 1 < totalRoomPlan}>
                                {/*  Room Plan Info Coming From Voyager Like Room Size, Bed Type, Amenities etc Starts Here */}
                                <RecommendedComboRoomInfo
                                  leftPanelProps={leftPanelProps}
                                  pwiData={roomPlanData?.pwi}
                                  isAltAcco={isAltAcco}
                                />
                                <UpsellComboInclusions
                                  rpt={roomPlanData?.name}
                                  det_inc={roomPlanData?.inclusionsList}
                                  cancellationPolicy={roomPlanData?.cancellationPolicy}
                                  cancellationPolicyTimeline={
                                    roomPlanData?.cancellationPolicyTimeline
                                  }
                                />
                              </S.MultiRoomRow>
                            );
                          },
                        );
                      })}

                      {/*  Room Plan Data Ends Here */}
                    </S.MainContentLeftDiv>
                    <S.MainContentRightDiv>
                      <RecommendedComboPrice
                        comboTariff={comboTariff}
                        roomData={roomData}
                        sellableType={item?.rooms?.[0]?.roomCategoryText}
                        onSelectClick={() => {
                          navigateToReviewPageCaller(item);
                          dispatch(
                            omnitureThunk(
                              omnitureConfig.pages.DetailsUnif,
                              omnitureConfig.events.selectRoom,
                            ),
                          );
                        }}
                        handlOpenCalendar={handlOpenCalendar}
                      />
                    </S.MainContentRightDiv>
                  </S.MainContentDiv>
                </S.MultiRoomComboSection>
              )}
            </>
          );
        })}
        {comboList.length > 1 && visibleItems < comboList.length && (
          <S.ComboOfferInnerSection>
            <S.ComboHeader>
              <S.ComboTextSpan>
                View {nonVisibleCombo} combo{nonVisibleCombo > 1 ? 's' : ''}
              </S.ComboTextSpan>
              <S.WrapperSpan onClick={() => showMoreCombos()}>
                <S.ArrowUpIconWrapperSpan>
                  <HappyArrowDropIcon
                    height="1rem"
                    width="1rem"
                    fill={defaultTheme.colors.goBrandBlue.base}
                    margin={'2px 0 0 0'}
                  />
                </S.ArrowUpIconWrapperSpan>
              </S.WrapperSpan>
            </S.ComboHeader>
          </S.ComboOfferInnerSection>
        )}
      </>
    );
  } else {
    return <>No Combos Available</>;
  }
};

export default RecommendedComboList;
